export default __webpack_public_path__ + "static/media/delete.b3f17d7a.svg";